import { QueryHookOptions, gql } from '@apollo/client'
import { LinkOnlyRedemptionBlockFragment, MultipleCodesRedemptionBlockFragment, Redemption, SingleCodeRedemptionBlockFragment } from 'app/features/offer/redemptions'
import { usePersistedCacheQuery } from 'app/hooks'

const query = gql`
  query fetchDiscountsHomeOffers($page: Int!, $limit: Int!, $dedupeIds: [String!]!) {
    fetchOffers(page: $page, limit: $limit, dedupeIds: $dedupeIds) {
      totalDocs
      page
      totalPages
      docs {
        id
        name
        description
        tag
        brand {
          id
          name
          slug
          logo {
            id
            url
            alt
          }
        }
        thumbnailImage {
          id
          url
          alt
        }
        slug
        redeemInList
        canRedeem
        offerLinkLabel
        redemptions {
          ${LinkOnlyRedemptionBlockFragment.partialFragment}
          ${MultipleCodesRedemptionBlockFragment.partialFragment}
          ${SingleCodeRedemptionBlockFragment.partialFragment}
        }
        isBookmarked
      }
    }
  }
`

export interface DiscountsHomeOffersQueryInput {
  page: number
  limit: number
  dedupeIds: string[]
}

export interface DiscountsHomeOffersQueryOutput {
  fetchOffers: {
    totalDocs: number
    page: number
    totalPages: number
    docs: {
      id: string
      name: string
      description: string
      tag: string
      brand: {
        id: string
        name: string
        slug: string
        logo: {
          url: string
        }
      }
      thumbnailImage: {
        id: string
        url: string
        alt: string
      }
      slug: string
      redeemInList: boolean
      canRedeem: boolean
      offerLinkLabel: string
      redemptions: Redemption[]
      isBookmarked: boolean
    }[]
  }
}

export const useDiscountsHomeOffersQuery = (
  options?: QueryHookOptions<DiscountsHomeOffersQueryOutput, DiscountsHomeOffersQueryInput>
) =>
  usePersistedCacheQuery<DiscountsHomeOffersQueryOutput, DiscountsHomeOffersQueryInput>(query, {
    ...options,
  })

export const fetchDiscountsHomeOffersQuery = { query }
